import {
  MIN_GUARANTEE_TEXT,
  MIN_LAWYER_LIABILITY_TEXT,
} from "@cle/constants/insuranceRequirements";

/**
 * Copy for the "Validering af forsikringspolice" info dialog.
 *
 * `validate_police` in cle-compliance-api scores exactly three fields —
 * insurance_company, lawyer_liability_amount, guarantee_amount. The card also
 * renders "Police startdato", but the API emits no result for it, so
 * `getFieldValidationItem` returns `showValidationState: false` and the row shows
 * a bare value. The text has to say so, or the one row without a ✓/✗ looks like a
 * bug.
 *
 * The two amounts come from the shared constant, so this text cannot drift from
 * the rule it describes.
 */
const InsurancePolicyValidationInfoContent = () => {
  return (
    <div className="d-flex flex-column gap-3">
      <p className="mb-0">
        Valideringen viser de oplysninger, der er læst på forsikringspolicen.
        Forsikringsselskab, advokatansvar og garantibeløb bliver vurderet og får
        et flueben, hvis de opfylder kravene, og et kryds, hvis de ikke gør.
        Under et felt med kryds står der, hvad der mangler eller ikke passer.
      </p>
      <p className="mb-0">
        Policens startdato vises til orientering og indgår ikke i vurderingen.
      </p>
      <p className="mb-0">
        Policen bliver afvist, hvis forsikringsselskabet ikke står på listen
        over godkendte selskaber, hvis advokatansvaret er under{" "}
        {MIN_LAWYER_LIABILITY_TEXT}, eller hvis garantibeløbet er under{" "}
        {MIN_GUARANTEE_TEXT}.
      </p>
      <p className="mb-0">
        Valideringen udføres af AI og kan lave fejl. Mener du, at vurderingen er
        forkert, kan du skrive til sekretariatet i kortet “Besked til
        sekretariatet”.
      </p>
    </div>
  );
};

export default InsurancePolicyValidationInfoContent;
